const name = /^(([A-Za-z-.'`\xC0-\xD6\xD8-\xF6\xF8-\xFF\u0100-\u017F])+\s*)+$/;
// eslint-disable-next-line max-len
const email = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
const postcode = /^[a-zA-Z]{1,2}[0-9R][0-9a-zA-Z]? *[0-9][a-zA-Z]{2}$/;

const allowedChars = /^[A-Za-z-!?\\.'`\xC0-\xD6\xD8-\xF6\xF8-\xFF\u0100-\u017F]*$/;
const mobileNumber = /^ *(0|([+] *4 *4)|(0 *0 *4 *4)) *7 *([0-9][ ]*){9}$/;
const phoneNumber = /(^( *(1 *8 *0 *0 *2)? *(0|([+] *4 *4)|(0 *0 *4 *4)) *([0-9][ ]*){9,10})?$)/;

export function cannotBeBlank(value) {
  return value.length > 0;
}

export function cannotBeBlankOrWhitespace(value) {
  return cannotBeBlank(value) && value.trim();
}

export function mustBeValidName(value) {
  return name.test(value);
}

export function mustBeValidEmail(value) {
  return email.test(value);
}

export function mustBeValidGbPostcode(value) {
  return postcode.test(value);
}

export function mustBeValidPhoneNumber(value) {
  return phoneNumber.test(value) || mobileNumber.test(value);
}
export function mustBeValidPhoneNumberOrEmpty(value) {
  return value === '' || mustBeValidPhoneNumber(value);
}

export function mustBeValidMobileNumber(value) {
  return mobileNumber.test(value);
}
export function mustBeValidMobileNumberOrEmpty(value) {
  return value === '' || mobileNumber.test(value);
}

export function cannotBeShorter(value, options) {
  if (!(options && options.min)) {
    throw new Error('You must pass min argument. Example: cannotBeShorter("Test", { min: 6 })');
  }
  return value.length >= options.min;
}

export function mustContainOnlyAllowedChars(value) {
  return allowedChars.test(value);
}

export function mustBeEqual(val1, val2) {
  return val1 === val2;
}
